import { useDashboardElectionSettingsWiseCsv } from '@hooks/useDashboardElectionSettingsWiseCSV';
import { useGetCountryReport } from '@hooks/useGetCountryReport';
import { DownloadButtons } from '@pentabd/ui';
import { t } from 'i18next';
import {
  countryReportCsvColumn,
  dashboardElectionWiseCsvColumn,
} from '../dashboard/components/constants';
import { allTimeSlots, autoSlotSelector } from '@utils/utils';
import { useForm } from 'react-hook-form';
import { useCustomParams } from '@hooks/useCustomParams';

export const DownloadCsvButtons = () => {
  const { searchParams } = useCustomParams();

  const election_schedule_id = searchParams.get('election_schedule_id');
  const methods = useForm({
    values: {
      time_range: autoSlotSelector().showSlotRange,
    },
  });
  const { register, watch } = methods;

  const { getDashboardElectionSettingsWiseCsv, dashboardElectionWiseCsvData } =
    useDashboardElectionSettingsWiseCsv();
  const { countryData, getCountryReportData } = useGetCountryReport();

  function onClickDownloadSettingsWiseData() {
    if (election_schedule_id)
      getDashboardElectionSettingsWiseCsv({
        election_schedule_id,
        time_range: watch('time_range'),
      });
  }

  function onClickDownloadCountryData() {
    if (election_schedule_id)
      getCountryReportData({
        election_schedule_id,
        time_range: watch('time_range'),
      });
  }

  return (
    <div className="d-flex gap-10 p-5 bg-extra-light mt-5">
      <select
        {...register('time_range')}
        className="w-25 dashboard-time shadow-sm"
      >
        <option value="">{t('DASHBOARD.SELECT_TIME')}</option>
        {allTimeSlots.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <DownloadButtons
        fileName="country-report-data"
        buttons={[{ name: 'csv', title: t('DASHBOARD.TOTAL_CSV') }]}
        columns={countryReportCsvColumn}
        rows={countryData as any}
        onClickDownload={onClickDownloadCountryData}
      />
      <DownloadButtons
        fileName="election-settings-wise-data"
        buttons={[{ name: 'csv', title: t('DASHBOARD.SETTINGS_CSV') }]}
        columns={dashboardElectionWiseCsvColumn}
        rows={dashboardElectionWiseCsvData}
        onClickDownload={onClickDownloadSettingsWiseData}
      />
    </div>
  );
};
